import { css as o } from "styled-components";
const f = o`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap');
  @font-face {
    font-family: 'Ford F-1';
    font-weight: 400;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordF-1-Regular.woff2') format('woff2');
    font-display: block;
  }
  @font-face {
    font-family: 'Ford F-1';
    font-weight: 500;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordF-1-Medium.woff2') format('woff2');
    font-display: block;
  }
  @font-face {
    font-family: 'Ford F-1';
    font-weight: 600;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordF-1-Semibold.woff2') format('woff2');
    font-display: block;
  }
  @font-face {
    font-family: 'FordMotion';
    font-weight: 400;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-Regular.woff2') format('woff2'),
      url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-Regular.woff') format('woff');
    font-display: block;
  }
  @font-face {
    font-family: 'FordMotion';
    font-weight: 500;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-Medium.woff2') format('woff2'),
      url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-Medium.woff') format('woff');
    font-display: block;
  }
  @font-face {
    font-family: 'FordMotion';
    font-weight: 600;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-SemiBold.woff2') format('woff2'),
      url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-SemiBold.woff') format('woff');
    font-display: block;
  }
`, r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FordProGlobalStyles: f
}, Symbol.toStringTag, { value: "Module" }));
export {
  f as F,
  r as f
};
